
export const SET_DOCUMENTS_FILTER = 'SET_DOCUMENTS_FILTER'

export const setDocumentFilter = ({ type, key, value }) => ({
  type: SET_DOCUMENTS_FILTER,
  payload: { type, key, value }
})
